<template>
  <div class="footer">
    <div :class="['links',isMobile?'lessMargin':'']">
      <a
          href="https://www.yininghealth.com"
          target="_blank"
      >奕宁健康</a>
      <a
          href="https://admin.yininghealth.com"
      >
        <HomeOutlined />
      </a>
    </div>
    <div class="copyright">
      Copyright
      <CopyrightOutlined />&nbsp;2022
      <span>奕宁健康</span>
    </div>
  </div>
</template>

<script>
import {isMobile} from "@/utils/device";
import { CopyrightOutlined, HomeOutlined } from '@ant-design/icons-vue'
export default {
  name: "GlobalFooter",
  components: {
    CopyrightOutlined,
    HomeOutlined,
  },
  setup() {
    return{
      isMobile,
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }

    &.lessMargin {
      a {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }
  }

  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>